import angular from 'angular';

export const ConstantsService = {
  // generalFiletypes: ['Auslieferungsbild', 'Ausstattungsbeschreibung', 'Ausweisdokument', 'Bestellung', 'Certificate of Conformity', 'Eingangsrechnung', 'Lieferschein', 'Transportschaden', 'Zulassungsbescheinigung I', 'Zulassungsbescheinigung II'],
  // generalLocations: {
  //   "SI": "Siegen",
  //   "GM": "Wiehl",
  //   "GL": "Burscheid",
  //   "AH2": "Autohaus 2000",
  //   "AHS": "Authoaus Schmidt",
  //   "AS": "Allrad Schmitt",
  //   "DI": "Parkplatz Dietrich Siegen",
  //   "EWK": "Erwin Klein Siegen",
  //   "WIL": "Wilscheidt"
  // },
  interfaceToastDuration: 2500,
  // salesCarTypes: {
  //   "DW": "Dienstwagen",
  //   "GW": "Gebrauchtwagen",
  //   "NW": "Neuwagen",
  //   "PVFW": "Geplanter Vorführwagen",
  //   "TZ": "Tageszulassung",
  //   "VFW": "Vorführwagen",
  //   "WST": "Werkstattwagen",
  //   "AL": "Bestand Anlagevermögen"
  // },
  salesCarStates: ['Reserviert', 'Veranstaltung', 'Verfügbar', 'Verkauft'],
  salesMakes: ['Abarth', 'Alfa Romeo', 'Fiat', 'Fiat Professional', 'Jeep'],
  salesFuelTypes: ['Benzin', 'Diesel', 'Plugin Hybrid Diesel', 'Plugin Hybrid Benzin', 'Mild Hybrid Benzin', 'Mild Hybrid Diesel', 'Vollelektrisch'],
  salesTransmissionTypes: ['Automatik', 'Schaltgetriebe'],
  salesDrivetrainTypes: ['Allradantrieb', 'Frontantrieb', 'Heckantrieb'],
  salesEmissionsclasses: ['Nicht vorhanden', 'Euro 4', 'Euro 5', 'Euro 6b', 'Euro 6c', 'Euro 6d Temp', 'Euro 6d'],
  salesEfficiencyClass: ['Nicht vorhanden', 'A+', 'A', 'B', 'C', 'D', 'E', 'F', 'G'],
  salesMaxReservationDays: 10,
  salesDefaultTransferCost: 850,
  // notificationsPushServiceKey: "BB7LM69FdPvC3xFyEAf74RgXTVZ7d7n1_ecyAKHnN-MbTT2wkA5qZv3gmtw5VuFRyLF_i1B17Y2S-_jLIZAFAlI"
};

export default angular.module('services.constantsService', [])
  .constant('constantsService', ConstantsService)
  .name;
